export default "__VITE_ASSET__bff380e2__"